// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const KeyboardArrowRight: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 17 26" enableBackground="new 0 0 17 26" xmlSpace="preserve">
<polygon fill="currentColor" fillRule="evenodd" clipRule="evenodd" points="3.83,0.98 0.9,3.92 10.44,13.48 0.9,23.04 3.83,25.98 16.33,13.48 "/>
</svg>;
};

export default React.memo(KeyboardArrowRight);
